// frontend/src/pages/test.js
import React, { useEffect, useState } from 'react';
import { testConnection } from '../api/api'; // ✅ صحيح حسب مجلدك

function Test() {
  const [status, setStatus] = useState('جارٍ التحقق...');

  useEffect(() => {
    testConnection().then(res => {
      setStatus(res.message);
    });
  }, []);

  return (
    <div>
      <h2>اختبار الاتصال</h2>
      <p>{status}</p>
    </div>
  );
}

export default Test;
